import React from "react";

const TechnicalSystemsSymbol = ({ family, color }) => {
  const common = {
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };

  switch (family) {
    case "pressure":
      return (
        <svg {...common}>
          <path d="M4 12h9" />
          <path d="M13 8l6 4-6 4z" />
          <circle cx="6" cy="12" r="2.2" />
        </svg>
      );

    case "gravity":
      return (
        <svg {...common}>
          <path d="M4 8h16" />
          <path d="M7 8v6a3 3 0 003 3h7" />
          <path d="M14 14l3 3 3-3" />
        </svg>
      );

    case "pumping":
      return (
        <svg {...common}>
          <circle cx="10" cy="12" r="4.5" />
          <path d="M14.2 9.8l5-2.4v9.2l-5-2.4" />
        </svg>
      );

    case "storage":
      return (
        <svg {...common}>
          <rect x="6" y="5" width="12" height="14" rx="2" />
          <path d="M9 9h6" />
          <path d="M9 13h6" />
        </svg>
      );

    case "hvac":
      return (
        <svg {...common}>
          <path d="M12 4v6" />
          <path d="M12 14c0 3-2 5-5 6" />
          <path d="M12 14c0 3 2 5 5 6" />
          <path d="M8 8c2 1 6 1 8 0" />
        </svg>
      );

    case "electrical":
      return (
        <svg {...common}>
          <path d="M13 3L7 13h4l-1 8 7-11h-4l0-7z" />
        </svg>
      );

    case "automation":
      return (
        <svg {...common}>
          <rect x="4" y="6" width="6" height="6" rx="1.5" />
          <rect x="14" y="6" width="6" height="6" rx="1.5" />
          <rect x="9" y="14" width="6" height="6" rx="1.5" />
          <path d="M10 9h4" />
          <path d="M17 12v2" />
          <path d="M12 12v2" />
        </svg>
      );

    case "process":
      return (
        <svg {...common}>
          <circle cx="7" cy="8" r="2.5" />
          <circle cx="17" cy="8" r="2.5" />
          <circle cx="12" cy="16" r="2.5" />
          <path d="M9 9.5l2 4" />
          <path d="M15 9.5l-2 4" />
        </svg>
      );

    default:
      return (
        <svg {...common}>
          <rect x="5" y="5" width="14" height="14" rx="3" />
        </svg>
      );
  }
};

export default TechnicalSystemsSymbol;